/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sales_Return_History_Not_RefundedInputs */

const vi_sales_return_history_not_refunded = /** @type {(inputs: Sales_Return_History_Not_RefundedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không hoàn tiền`)
};

/**

* @param {Sales_Return_History_Not_RefundedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sales_return_history_not_refunded = /** @type {((inputs?: Sales_Return_History_Not_RefundedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sales_Return_History_Not_RefundedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sales_return_history_not_refunded(inputs)
});